/** Search/Filter */
export enum BookingSystemEvents {
  Created = "Created",
  UpdateAccStatus = "UpdateAccStatus",
  UpdateTravelStatus = "UpdateTravelStatus",
  UpdateFinanceStatus = "UpdateFinanceStatus",
  UpdatePatientId = "UpdatePatientId",
  InvoicePaidOn = "InvoicePaidOn",
  InvoicePaidOff = "InvoicePaidOff",
  InvoicePaidOnEmp = "InvoicePaidOnEmp",
  InvoicePaidOffEmp = "InvoicePaidOffEmp",
  EditCost = "EditCost",
  RemoveSubcontractorDocument = "RemoveSubcontractorDocument",
  UploadSubcontractorDocument = "UploadSubcontractorDocument",
  UpdateSubContractorInvoice = "UpdateSubContractorInvoice",
  UploadSubCustomerInvoice = "UploadSubCustomerInvoice",
  RemoveCustomerInvoice = "RemoveCustomerInvoice",
  WriteNote = "WriteNote",
  AdditionalWorkOn = "AdditionalWorkOn",
  AdditionalWorkOff = "AdditionalWorkOff",
  Canceled = "Canceled",
  Restored = "Restored",
  True = "True",
  False = "False",
  SaveInvoice = "SaveInvoice",
  RemoveAccConfirmation = "RemoveAccConfirmation",
  RemoveTravelConfirmation = "RemoveTravelConfirmation",
  RestoreAccConfirmation = "RestoreAccConfirmation",
  RestoreTravelConfirmation = "RestoreTravelConfirmation",
  UpdateWorkedHours = "UpdateWorkedHours"
}
